<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    export default {
        name: 'certificatesModal',
        data () {
            return {
                maximized: false
            }
        },
        computed: {
            ...mapState({
                certificatesModal: s => s.shared.certificatesModal,
                startDate: s => s.reports.certificates.startDate,
                endDate: s => s.reports.certificates.endDate
            })
        },
        methods: {
            ...mapMutations([
                'closeModal'
            ]),
            ...mapMutations('reports',[
                'changeState'
            ]),
            toggleMaximized(){
                this.maximized = !this.maximized
            }
        }
    }
</script>

<template>
    <q-modal class="sl-modal"
    id="certificatesModal"
    :maximized="maximized"
    :value="certificatesModal"
    @hide="closeModal('certificates')"
    >
    <q-modal-layout>
        <q-toolbar slot="header">
            <q-toolbar-title>
                <q-icon name="fa fa-certificate" /> Certificates Report
            </q-toolbar-title>
            <!--<q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />-->
            <q-icon @click.native="closeModal('certificates')" name="clear" />
        </q-toolbar>
        <div style="padding:40px 20px">
            <div class="sl-row">
                <div class="sl-col-12">
                    <p style="max-width:350px; margin:0 auto" class="text-center">This report shows all the printed certificates for a given date range.</p>
                </div>
            </div>
            <div class="sl-row sl-vp">
                <div class="sl-col-6">
                    <q-datetime stack-label="Start Date" :value="startDate" @change="val=>changeState({area:'certificates',field:'startDate',val:val})" />
                </div>
                <div class="sl-col-6">
                    <q-datetime stack-label="End Date" :value="endDate" @change="val=>changeState({area:'certificates',field:'endDate',val:val})" />
                </div>
            </div>
        </div>
        <q-toolbar slot="footer">
            <q-toolbar-title></q-toolbar-title>
            <q-btn color="green" @click.native="save" icon="fa fa-gear" label="Run" />&nbsp;
            <q-btn outline color="faded" @click.native="closeModal('certificates')" label="Cancel" />
        </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<style lang="stylus">
</style>